import { useEffect, useCallback, useState } from 'react';

type TUseContextMenu = {
  elementRef: React.RefObject<HTMLElement>;
  onShowContextMenu: (event: MouseEvent) => boolean;
  onHideContextMenu: () => void;
  isEnabled?: boolean;
};

export const useContextMenu = ({
  elementRef,
  onHideContextMenu,
  onShowContextMenu,
  isEnabled = false,
}: TUseContextMenu) => {
  const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });
  const [show, setShow] = useState(false);

  const handleContextMenu = useCallback(
    (event: MouseEvent) => {
      if (!isEnabled) {
        return;
      }

      event.preventDefault();
      setAnchorPoint({ x: event.pageX, y: event.pageY });
      setShow(onShowContextMenu(event));
    },
    [setShow, setAnchorPoint, onShowContextMenu, isEnabled],
  );

  const closeContextMenu = useCallback(() => {
    setShow(false);
    onHideContextMenu();
  }, [onHideContextMenu]);

  useEffect(() => {
    const element = elementRef.current;
    if (element) {
      element.addEventListener('contextmenu', handleContextMenu);
    }

    return () => {
      if (element) {
        element.removeEventListener('contextmenu', handleContextMenu);
      }
    };
  });

  return { anchorPoint, show, closeContextMenu };
};
